import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import HeaderBack from '../../../../components/mobile/HeaderBack';
import ReactHtmlParser from 'react-html-parser'

const data = "<p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up</p><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><ul><li>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</li><li>The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.</li><li>Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites</li><li>Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</li><li>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage,</li></ul>"

function MobileReadDetailScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/knowledge-bank/detail/read')
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('knowledge-bank:goBack')}
        title={'Post Title 01'}
      />
      <Box marginTop={26} marginBottom={26}>
        {ReactHtmlParser(data)}
      </Box>
    </>
  );
}

export default MobileReadDetailScreen;
